import {
  Field,
  GraphQLLocalDateTime,
  GraphQLTimestamp,
  InputType,
  registerEnumType,
} from '@warebee/shared/util-backend-only-types';

export enum StringSearchFilterType {
  CONTAINS = 'CONTAINS',
  EQ = 'EQ',
  EQ_CI = 'EQ_CI',
  STARTS_WITH = 'STARTS_WITH',
}

registerEnumType(StringSearchFilterType, {
  name: 'StringSearchFilterType',
});

@InputType()
export class StringSearchFilter {
  @Field(() => StringSearchFilterType, {
    defaultValue: StringSearchFilterType.CONTAINS,
  })
  type?: StringSearchFilterType;

  @Field()
  value: string;
}

export enum NumberSearchFilterType {
  EQ = 'EQ',
  GE = 'GE',
  GT = 'GT',
  LE = 'LE',
  LT = 'LT',
}

registerEnumType(NumberSearchFilterType, {
  name: 'NumberSearchFilterType',
});

@InputType()
export class NumberSearchFilter {
  @Field(() => NumberSearchFilterType, {
    defaultValue: NumberSearchFilterType.EQ,
  })
  type: NumberSearchFilterType;

  @Field()
  value: number;
}

@InputType()
export class BooleanSearchFilter {
  @Field()
  value: boolean;
}

@InputType()
export class LocalDateTimeSearchFilter {
  @Field(() => GraphQLLocalDateTime, { nullable: true })
  from?: string;

  @Field({ nullable: true, defaultValue: false })
  excludeFrom?: boolean;

  @Field(() => GraphQLLocalDateTime, { nullable: true })
  to?: string;

  @Field({ nullable: true, defaultValue: false })
  excludeTo?: boolean;
}

@InputType()
export class TimestampSearchFilter {
  @Field(() => GraphQLTimestamp, { nullable: true })
  from?: Date;

  @Field({ nullable: true, defaultValue: false })
  excludeFrom?: boolean;

  @Field(() => GraphQLTimestamp, { nullable: true })
  to?: Date;

  @Field({ nullable: true, defaultValue: false })
  excludeTo?: boolean;
}
